/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DropLiveStatusPerPlatform } from './DropLiveStatusPerPlatform';
import {
    DropLiveStatusPerPlatformFromJSON,
    DropLiveStatusPerPlatformFromJSONTyped,
    DropLiveStatusPerPlatformToJSON,
    DropLiveStatusPerPlatformToJSONTyped,
} from './DropLiveStatusPerPlatform';

/**
 * 
 * @export
 * @interface DropLiveStatusResponse
 */
export interface DropLiveStatusResponse {
    /**
     * 
     * @type {string}
     * @memberof DropLiveStatusResponse
     */
    primaryLivePlatform: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DropLiveStatusResponse
     */
    anyLive: boolean;
    /**
     * 
     * @type {Array<DropLiveStatusPerPlatform>}
     * @memberof DropLiveStatusResponse
     */
    platforms: Array<DropLiveStatusPerPlatform>;
    /**
     * 
     * @type {number}
     * @memberof DropLiveStatusResponse
     */
    computedAt: number;
}

/**
 * Check if a given object implements the DropLiveStatusResponse interface.
 */
export function instanceOfDropLiveStatusResponse(value: object): value is DropLiveStatusResponse {
    if (!('primaryLivePlatform' in value) || value['primaryLivePlatform'] === undefined) return false;
    if (!('anyLive' in value) || value['anyLive'] === undefined) return false;
    if (!('platforms' in value) || value['platforms'] === undefined) return false;
    if (!('computedAt' in value) || value['computedAt'] === undefined) return false;
    return true;
}

export function DropLiveStatusResponseFromJSON(json: any): DropLiveStatusResponse {
    return DropLiveStatusResponseFromJSONTyped(json, false);
}

export function DropLiveStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropLiveStatusResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'primaryLivePlatform': json['primaryLivePlatform'],
        'anyLive': json['anyLive'],
        'platforms': ((json['platforms'] as Array<any>).map(DropLiveStatusPerPlatformFromJSON)),
        'computedAt': json['computedAt'],
    };
}

export function DropLiveStatusResponseToJSON(json: any): DropLiveStatusResponse {
    return DropLiveStatusResponseToJSONTyped(json, false);
}

export function DropLiveStatusResponseToJSONTyped(value?: DropLiveStatusResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'primaryLivePlatform': value['primaryLivePlatform'],
        'anyLive': value['anyLive'],
        'platforms': ((value['platforms'] as Array<any>).map(DropLiveStatusPerPlatformToJSON)),
        'computedAt': value['computedAt'],
    };
}

